// @generated by protoc-gen-es v1.6.0 with parameter "target=ts"
// @generated from file dymensionxyz/dymension/eibc/tx.proto (package dymensionxyz.dymension.eibc, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Coin, DecProto, IntProto } from "../../cosmos/base/v1beta1/coin_pb.js";

/**
 * MsgFulfillOrder defines the FulfillOrder request type.
 *
 * @generated from message dymensionxyz.dymension.eibc.MsgFulfillOrder
 */
export class MsgFulfillOrder extends Message<MsgFulfillOrder> {
  /**
   * fulfiller_address is the bech32-encoded address of the account which the message was sent from.
   *
   * @generated from field: string fulfiller_address = 1;
   */
  fulfillerAddress = "";

  /**
   * order_id is the unique identifier of the order to be fulfilled.
   *
   * @generated from field: string order_id = 2;
   */
  orderId = "";

  /**
   * expected_fee is the nominal fee set in the order.
   *
   * @generated from field: string expected_fee = 3;
   */
  expectedFee = "";

  constructor(data?: PartialMessage<MsgFulfillOrder>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.eibc.MsgFulfillOrder";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "fulfiller_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "expected_fee", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MsgFulfillOrder {
    return new MsgFulfillOrder().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MsgFulfillOrder {
    return new MsgFulfillOrder().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MsgFulfillOrder {
    return new MsgFulfillOrder().fromJsonString(jsonString, options);
  }

  static equals(a: MsgFulfillOrder | PlainMessage<MsgFulfillOrder> | undefined, b: MsgFulfillOrder | PlainMessage<MsgFulfillOrder> | undefined): boolean {
    return proto3.util.equals(MsgFulfillOrder, a, b);
  }
}

/**
 * MsgFulfillOrderResponse defines the FulfillOrder response type.
 *
 * @generated from message dymensionxyz.dymension.eibc.MsgFulfillOrderResponse
 */
export class MsgFulfillOrderResponse extends Message<MsgFulfillOrderResponse> {
  constructor(data?: PartialMessage<MsgFulfillOrderResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.eibc.MsgFulfillOrderResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MsgFulfillOrderResponse {
    return new MsgFulfillOrderResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MsgFulfillOrderResponse {
    return new MsgFulfillOrderResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MsgFulfillOrderResponse {
    return new MsgFulfillOrderResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MsgFulfillOrderResponse | PlainMessage<MsgFulfillOrderResponse> | undefined, b: MsgFulfillOrderResponse | PlainMessage<MsgFulfillOrderResponse> | undefined): boolean {
    return proto3.util.equals(MsgFulfillOrderResponse, a, b);
  }
}

/**
 * MsgFulfillOrderAuthorized defines the FulfillOrderAuthorized request type.
 *
 * @generated from message dymensionxyz.dymension.eibc.MsgFulfillOrderAuthorized
 */
export class MsgFulfillOrderAuthorized extends Message<MsgFulfillOrderAuthorized> {
  /**
   * order_id is the unique identifier of the order to be fulfilled.
   *
   * @generated from field: string order_id = 1;
   */
  orderId = "";

  /**
   * rollapp_id is the unique identifier of the rollapp that the order is associated with.
   *
   * @generated from field: string rollapp_id = 2;
   */
  rollappId = "";

  /**
   * price is the price of the demand order
   *
   * @generated from field: repeated cosmos.base.v1beta1.Coin price = 3;
   */
  price: Coin[] = [];

  /**
   * amount is the amount of the IBC transfer
   *
   * @generated from field: cosmos.base.v1beta1.IntProto amount = 4;
   */
  amount?: IntProto;

  /**
   * lp_address is the bech32-encoded address of the account which the authorization was granted from.
   * This account will receive the price amount at the finalization phase.
   *
   * @generated from field: string lp_address = 5;
   */
  lpAddress = "";

  /**
   * operator_fee_address is an optional bech32-encoded address of an account that would collect the operator_fee_part
   * if it's empty, the operator_fee_part will go to the operator_address
   *
   * @generated from field: string operator_fee_address = 6;
   */
  operatorFeeAddress = "";

  /**
   * expected_fee is the nominal fee set in the order.
   *
   * @generated from field: string expected_fee = 7;
   */
  expectedFee = "";

  /**
   * operator_fee_share is the share of the fee earnings that goes to the operator
   * it will be deduced from the fee of the demand order and paid out immediately
   *
   * @generated from field: cosmos.base.v1beta1.DecProto operator_fee_share = 8;
   */
  operatorFeeShare?: DecProto;

  /**
   * settlement_validated signals if the block behind the demand order needs to be "settlement validated" or not
   *
   * @generated from field: bool settlement_validated = 9;
   */
  settlementValidated = false;

  constructor(data?: PartialMessage<MsgFulfillOrderAuthorized>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.eibc.MsgFulfillOrderAuthorized";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "rollapp_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "price", kind: "message", T: Coin, repeated: true },
    { no: 4, name: "amount", kind: "message", T: IntProto },
    { no: 5, name: "lp_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "operator_fee_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "expected_fee", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "operator_fee_share", kind: "message", T: DecProto },
    { no: 9, name: "settlement_validated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MsgFulfillOrderAuthorized {
    return new MsgFulfillOrderAuthorized().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MsgFulfillOrderAuthorized {
    return new MsgFulfillOrderAuthorized().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MsgFulfillOrderAuthorized {
    return new MsgFulfillOrderAuthorized().fromJsonString(jsonString, options);
  }

  static equals(a: MsgFulfillOrderAuthorized | PlainMessage<MsgFulfillOrderAuthorized> | undefined, b: MsgFulfillOrderAuthorized | PlainMessage<MsgFulfillOrderAuthorized> | undefined): boolean {
    return proto3.util.equals(MsgFulfillOrderAuthorized, a, b);
  }
}

/**
 * @generated from message dymensionxyz.dymension.eibc.MsgFulfillOrderAuthorizedResponse
 */
export class MsgFulfillOrderAuthorizedResponse extends Message<MsgFulfillOrderAuthorizedResponse> {
  constructor(data?: PartialMessage<MsgFulfillOrderAuthorizedResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.eibc.MsgFulfillOrderAuthorizedResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MsgFulfillOrderAuthorizedResponse {
    return new MsgFulfillOrderAuthorizedResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MsgFulfillOrderAuthorizedResponse {
    return new MsgFulfillOrderAuthorizedResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MsgFulfillOrderAuthorizedResponse {
    return new MsgFulfillOrderAuthorizedResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MsgFulfillOrderAuthorizedResponse | PlainMessage<MsgFulfillOrderAuthorizedResponse> | undefined, b: MsgFulfillOrderAuthorizedResponse | PlainMessage<MsgFulfillOrderAuthorizedResponse> | undefined): boolean {
    return proto3.util.equals(MsgFulfillOrderAuthorizedResponse, a, b);
  }
}

/**
 * @generated from message dymensionxyz.dymension.eibc.MsgUpdateDemandOrder
 */
export class MsgUpdateDemandOrder extends Message<MsgUpdateDemandOrder> {
  /**
   * owner_address is the bech32-encoded address of the account owns the order.
   * This is expected to be the address of the order recipient.
   *
   * @generated from field: string owner_address = 1;
   */
  ownerAddress = "";

  /**
   * order_id is the unique identifier of the order to be updated.
   *
   * @generated from field: string order_id = 2;
   */
  orderId = "";

  /**
   * new_fee is the new fee amount to be set in the order.
   *
   * @generated from field: string new_fee = 3;
   */
  newFee = "";

  constructor(data?: PartialMessage<MsgUpdateDemandOrder>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.eibc.MsgUpdateDemandOrder";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "owner_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "new_fee", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MsgUpdateDemandOrder {
    return new MsgUpdateDemandOrder().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MsgUpdateDemandOrder {
    return new MsgUpdateDemandOrder().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MsgUpdateDemandOrder {
    return new MsgUpdateDemandOrder().fromJsonString(jsonString, options);
  }

  static equals(a: MsgUpdateDemandOrder | PlainMessage<MsgUpdateDemandOrder> | undefined, b: MsgUpdateDemandOrder | PlainMessage<MsgUpdateDemandOrder> | undefined): boolean {
    return proto3.util.equals(MsgUpdateDemandOrder, a, b);
  }
}

/**
 * @generated from message dymensionxyz.dymension.eibc.MsgUpdateDemandOrderResponse
 */
export class MsgUpdateDemandOrderResponse extends Message<MsgUpdateDemandOrderResponse> {
  constructor(data?: PartialMessage<MsgUpdateDemandOrderResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.eibc.MsgUpdateDemandOrderResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MsgUpdateDemandOrderResponse {
    return new MsgUpdateDemandOrderResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MsgUpdateDemandOrderResponse {
    return new MsgUpdateDemandOrderResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MsgUpdateDemandOrderResponse {
    return new MsgUpdateDemandOrderResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MsgUpdateDemandOrderResponse | PlainMessage<MsgUpdateDemandOrderResponse> | undefined, b: MsgUpdateDemandOrderResponse | PlainMessage<MsgUpdateDemandOrderResponse> | undefined): boolean {
    return proto3.util.equals(MsgUpdateDemandOrderResponse, a, b);
  }
}

